import React from "react";
import { Modal } from "react-bootstrap";
import "../../css/rentals/rentals.css";

class RentalCancelEndRequestModal extends React.Component {
  render() {
    const {
      show,
      rental,
      isLoading,
      onClose,
      onConfirm,
    } = this.props;

    if (!show || !rental) return null;

    const productName = rental.product_name || (rental.product ? rental.product.designation : "Produit");

    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop={isLoading ? "static" : true}
        keyboard={!isLoading}
        centered
        size="md"
        className="rental-cancel-end-request-modal"
        dialogClassName="modal-dialog-rounded"
      >
        <Modal.Header style={{ backgroundColor: '#dc3545', color: 'white', borderTopLeftRadius: '0.5rem', borderTopRightRadius: '0.5rem' }}>
          <Modal.Title className="rental-modal-title">
            Annuler la demande de fin
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="rental-modal-body">
          <div className="rental-modal-body-inner">
            <h5 className="rental-modal-product-name">
              Confirmer l'annulation
            </h5>
            <p className="rental-modal-form-hint">
              Êtes-vous sûr de vouloir annuler votre demande de fin de location pour <strong>{productName}</strong> ?
            </p>
            <p className="rental-modal-form-hint">
              La location repassera au statut <strong className="text-success">Actif</strong>.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="rental-modal-footer" style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="btn btn-secondary"
            style={{ flex: 1 }}
          >
            Non
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="btn btn-danger"
            style={{ flex: 1 }}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span> Annulation en cours...</span>
              </>
            ) : (
              "Oui"
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RentalCancelEndRequestModal;
